import React, { useEffect } from "react";
import Helper from "../functions/Helper.js";
import { Box } from "@mui/material";
import Phase from "./Phase.js";
import { loadFont } from "@remotion/google-fonts/PublicSans";

const PhaseScreen = (props) => {
  return (
    <Box
      key={props.phase.id}
      id={props.prefix + "phase_screen_" + +props.phase.id}
      sx={{
        opacity: 0,
        display: "flex",
        position: "absolute",
        color: "grey.100",
        inset: 0,
        bottom: 5,
        alignItems: "center",
        justifyContent: "center",
        fontSize: 40 * props.fontSizeResizeFactor,
        fontWeight: 600,
        backgroundColor: "rgba(0,0,0,.7)",
      }}
    >
      <Box
        sx={{
          px: 5,
          py: 2,
          textAlign: "center",
          fontFamily: props.fontFamily,
        }}
      >
        {Helper.getPhaseTitle(props.phase, props.phases)}
      </Box>
    </Box>
  );
};

export default function FullPlayAnimator(props) {
  let phases = props.data.phases.phases;
  const { fontFamily } = loadFont();
  let fontSizeResizeFactor = props.width ? props.width / 600 : 1;
  let seekPos = props.seekPos ?? 0;

  useEffect(() => {
    if (props.seek) {
      props.seek(seekPos);

      if (props.onMeasuredDuration) {
        props.onMeasuredDuration(props.returnDuration());
      }
    }
  }, [seekPos]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box id={props.prefix + "wrapper_" + phases[0].id}>
        <Phase
          mirror={props.mirror}
          objectSizeFactor={props.data.settings.objectSizeFactor}
          uId={props.prefix + phases[0].id}
          courtColor={props.data.settings.courtColor}
          id={phases[0].id}
          editable={false}
          animatable={true}
          court={props.data.settings.editor.court}
          dispatch={() => {}}
          phase={phases[0]}
        />
      </Box>

      {phases.slice(1).map((phase, index) => (
        <Box
          key={phase.id}
          sx={{ position: "absolute", inset: 0, opacity: 0 }}
          id={props.prefix + "wrapper_" + phase.id}
        >
          <Phase
            mirror={props.mirror}
            objectSizeFactor={props.data.settings.objectSizeFactor}
            uId={props.prefix + phase.id}
            courtColor={props.data.settings.courtColor}
            id={phase.id}
            editable={false}
            animatable={true}
            court={props.data.settings.editor.court}
            dispatch={() => {}}
            phase={phase}
          />
        </Box>
      ))}

      {phases.map((phase, index) => (
        <PhaseScreen
          key={index}
          prefix={props.prefix}
          phase={phase}
          phases={phases}
          fontFamily={fontFamily}
          fontSizeResizeFactor={fontSizeResizeFactor}
        />
      ))}

      {props.showTitle && (
        <Box
          id={"title_screen"}
          sx={{
            fontFamily,
            textAlign: "center",
            opacity: 1,
            display: "flex",
            position: "absolute",
            color: "#fff",
            inset: 0,
            bottom: 5,
            alignItems: "center",
            justifyContent: "center",
            fontSize: 40 * fontSizeResizeFactor,
            lineHeight: 1.4,
            fontWeight: 600,
            backgroundColor: "rgba(0,0,0,.7)",
            padding: 5 * fontSizeResizeFactor,
          }}
        >
          {props.title}
        </Box>
      )}
    </Box>
  );
}
